import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalDatosComponent } from './portal-datos/portal-datos.component';
import { CoreModule } from '../core/core.module';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from '../../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilModule } from '../util/util.module';
import { ObservatorioRoutingModule } from './observatorio-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReportComponent } from './report/report.component';
import { DownloadDBComponent } from './download-db/download-db.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalEmailComponent } from './modal-email/modal-email.component';
import { DescargasComponent } from './descargas/descargas.component';
import { ModalDownloadComponent } from './modal-download/modal-download.component';

@NgModule({
  declarations: [
    PortalDatosComponent,
    ReportComponent,
    DownloadDBComponent,
    ModalEmailComponent,
    DescargasComponent,
    ModalDownloadComponent,
  ],
  imports: [
    CommonModule,
    UtilModule,
    CoreModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    AppRoutingModule,
    ObservatorioRoutingModule,
    NgSelectModule,
    TranslatePipe,
  ],
})
export class ObservatorioModule {}
